import { SearchFormData } from '@/features/approving_invoice_reports/components/Search/hooks/useSearchForm';
import { PropsControl } from '@/features/approving_invoice_reports/components/Search/type';
import { FormCheckbox } from '@moneyforward/ap-frontend-components';

export const FormCheckBox = ({ control, name, labelProps }: PropsControl) => {
  return (
    <FormCheckbox<SearchFormData>
      control={control}
      name={name}
      inputId={name}
      testId={name}
      label={labelProps?.text}
    />
  );
};
